import {round} from './Internal/round';
import {Fraction} from '../../../Domain/Fraction';

export function formatRelativePeakForcePosition(relativePeakForcePosition: Fraction | null): {
    formatted: string;
    unit?: string;
} {
    if (relativePeakForcePosition === null) {
        return {formatted: '-'};
    }
    return {formatted: round(relativePeakForcePosition.percentage, 1), unit: '%'};
}

export function formatAverageRelativePeakForcePosition(relativePeakForcePosition: Fraction | null): {
    formatted: string;
    unit?: string;
} {
    if (relativePeakForcePosition === null) {
        return {formatted: '-'};
    }
    return {formatted: round(relativePeakForcePosition.percentage, 1), unit: '%'};
}
